import clsx from "clsx";
import { memo, type PropsWithChildren, type NamedExoticComponent } from "react";

import type { IClassName, IRowProps } from "./types";
import classes from "./styles.module.scss";

import { ContentDivider } from "@components/atoms/contentDivider";

const Row = memo(function Row(props: PropsWithChildren<IRowProps>) {
  const { children, className, gap, noBorder } = props;

  return (
    <>
      <div className={clsx([gap && `gap-${gap}`, className, classes.row])}>
        {children}
      </div>
      {!noBorder && <ContentDivider />}
    </>
  );
}) as NamedExoticComponent<PropsWithChildren<IRowProps>> & {
  Input: NamedExoticComponent<PropsWithChildren<IClassName>>;
  Field: NamedExoticComponent<PropsWithChildren<IClassName>>;
};

const Input = memo(function Input(props: PropsWithChildren<IClassName>) {
  const { children, className } = props;

  return (
    <div className={clsx([className, classes["row-input"]])}>{children}</div>
  );
});

const Field = memo(function Field(props: PropsWithChildren<IClassName>) {
  const { children, className } = props;

  return (
    <div className={clsx([className, classes["row-field"]])}>{children}</div>
  );
});

Row.Input = Input;
Row.Field = Field;
export { Row };

Row.displayName = "Row";
